import styled from 'styled-components';

const VideoStyles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  margin: auto;
  margin-top: 60px;

  .video-js .vjs-menu-button-inline.vjs-slider-active,
  .video-js .vjs-menu-button-inline:focus,
  .video-js .vjs-menu-button-inline:hover,
  .video-js.vjs-no-flex .vjs-menu-button-inline {
    width: 10em;
  }

  .video-js .vjs-controls-disabled .vjs-big-play-button {
    display: none !important;
  }

  .video-js .vjs-control {
    width: 3em;
  }

  .video-js .vjs-menu-button-inline:before {
    width: 1.5em;
  }

  .vjs-menu-button-inline .vjs-menu {
    left: 3em;
  }

  .vjs-paused.vjs-has-started.video-js .vjs-big-play-button,
  .video-js.vjs-ended .vjs-big-play-button,
  .video-js.vjs-paused .vjs-big-play-button {
    display: block;
  }

  .video-js .vjs-load-progress div,
  .vjs-seeking .vjs-big-play-button,
  .vjs-waiting .vjs-big-play-button {
    display: none !important;
  }

  .video-js .vjs-mouse-display:after,
  .video-js .vjs-play-progress:after {
    padding: 0 0.4em 0.3em;
  }

  .video-js.vjs-ended .vjs-loading-spinner {
    display: none;
  }

  .video-js.vjs-ended .vjs-big-play-button {
    display: block !important;
  }

  .video-js *,
  .video-js:after,
  .video-js:before {
    box-sizing: inherit;
    font-size: inherit;
    color: inherit;
  }

  .video-js.vjs-fullscreen,
  .video-js.vjs-fullscreen .vjs-tech {
    width: 100% !important;
    height: 100% !important;
  }

  .video-js .vjs-menu-button-inline.vjs-slider-active,
  .video-js .vjs-menu-button-inline:focus,
  .video-js .vjs-menu-button-inline:hover,
  .video-js.vjs-no-flex .vjs-menu-button-inline {
    width: 10em;
  }

  .video-js .vjs-controls-disabled .vjs-big-play-button {
    display: none !important;
  }

  .video-js .vjs-control {
    width: 3em;
  }

  .video-js .vjs-menu-button-inline:before {
    width: 1.5em;
  }

  .vjs-menu-button-inline .vjs-menu {
    left: 3em;
  }

  .vjs-paused.vjs-has-started.video-js .vjs-big-play-button,
  .video-js.vjs-ended .vjs-big-play-button,
  .video-js.vjs-paused .vjs-big-play-button {
    display: block;
  }

  .video-js .vjs-load-progress div,
  .vjs-seeking .vjs-big-play-button,
  .vjs-waiting .vjs-big-play-button {
    display: none !important;
  }

  .video-js .vjs-mouse-display:after,
  .video-js .vjs-play-progress:after {
    padding: 0 0.4em 0.3em;
  }

  .video-js.vjs-ended .vjs-loading-spinner {
    display: none;
  }

  .video-js.vjs-ended .vjs-big-play-button {
    display: block !important;
  }

  .video-js *,
  .video-js:after,
  .video-js:before {
    box-sizing: inherit;
    font-size: inherit;
    color: inherit;
  }

  .video-js.vjs-fullscreen,
  .video-js.vjs-fullscreen .vjs-tech {
    width: 100% !important;
    height: 100% !important;
  }

  .video-js {
    font-size: 14px;
    overflow: hidden;
  }

  .video-js .vjs-control {
    color: inherit;
  }

  .video-js .vjs-menu-button-inline:hover,
  .video-js.vjs-no-flex .vjs-menu-button-inline {
    width: 8.35em;
  }

  .video-js
    .vjs-volume-menu-button.vjs-volume-menu-button-horizontal:hover
    .vjs-menu
    .vjs-menu-content {
    height: 3em;
    width: 6.35em;
  }

  .video-js .vjs-control:focus:before,
  .video-js .vjs-control:hover:before {
    text-shadow: 0 0 1em #fff, 0 0 1em #fff, 0 0 1em #fff;
  }

  .video-js .vjs-spacer,
  .video-js .vjs-time-control {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-flex: 1 1 auto;
    -moz-box-flex: 1 1 auto;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
  }

  .video-js .vjs-time-control {
    -webkit-box-flex: 0 1 auto;
    -moz-box-flex: 0 1 auto;
    -webkit-flex: 0 1 auto;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    width: auto;
  }

  .video-js .vjs-time-control.vjs-time-divider {
    width: 14px;
  }

  .video-js .vjs-time-control.vjs-time-divider div {
    width: 100%;
    text-align: center;
  }

  .video-js .vjs-time-control.vjs-current-time {
    margin-left: 1em;
  }

  .video-js .vjs-time-control .vjs-current-time-display,
  .video-js .vjs-time-control .vjs-duration-display {
    width: 100%;
  }

  .video-js .vjs-time-control .vjs-current-time-display {
    text-align: right;
  }

  .video-js .vjs-time-control .vjs-duration-display {
    text-align: left;
  }

  .video-js .vjs-play-progress:before,
  .video-js .vjs-progress-control .vjs-play-progress:before,
  .video-js .vjs-remaining-time,
  .video-js .vjs-volume-level:after,
  .video-js .vjs-volume-level:before,
  .video-js.vjs-live .vjs-time-control.vjs-current-time,
  .video-js.vjs-live .vjs-time-control.vjs-duration,
  .video-js.vjs-live .vjs-time-control.vjs-time-divider,
  .video-js.vjs-no-flex .vjs-time-control.vjs-remaining-time {
    display: none;
  }

  .video-js.vjs-no-flex .vjs-time-control {
    display: table-cell;
    width: 4em;
  }

  .video-js .vjs-progress-control {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 0.5em;
    top: -0.5em;
  }

  .video-js .vjs-progress-control .vjs-load-progress,
  .video-js .vjs-progress-control .vjs-play-progress,
  .video-js .vjs-progress-control .vjs-progress-holder {
    height: 100%;
  }

  .video-js .vjs-progress-control .vjs-progress-holder {
    margin: 0;
  }

  .video-js .vjs-progress-control:hover {
    height: 1.5em;
    top: -1.5em;
  }

  .video-js .vjs-control-bar {
    -webkit-transition: -webkit-transform 0.1s ease 0s;
    -moz-transition: -moz-transform 0.1s ease 0s;
    -ms-transition: -ms-transform 0.1s ease 0s;
    -o-transition: -o-transform 0.1s ease 0s;
    transition: transform 0.1s ease 0s;
  }

  .video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-active
    .vjs-control-bar,
  .video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-inactive
    .vjs-control-bar,
  .video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-active
    .vjs-control-bar,
  .video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-inactive
    .vjs-control-bar,
  .video-js.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-control-bar {
    visibility: visible;
    opacity: 1;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translateY(3em);
    -moz-transform: translateY(3em);
    -ms-transform: translateY(3em);
    -o-transform: translateY(3em);
    transform: translateY(3em);
    -webkit-transition: -webkit-transform 1s ease 0s;
    -moz-transition: -moz-transform 1s ease 0s;
    -ms-transition: -ms-transform 1s ease 0s;
    -o-transition: -o-transform 1s ease 0s;
    transition: transform 1s ease 0s;
  }

  .video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-active
    .vjs-progress-control,
  .video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-inactive
    .vjs-progress-control,
  .video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-active
    .vjs-progress-control,
  .video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-inactive
    .vjs-progress-control,
  .video-js.vjs-has-started.vjs-playing.vjs-user-inactive
    .vjs-progress-control {
    height: 0.25em;
    top: -0.25em;
    pointer-events: none;
    -webkit-transition: height 1s, top 1s;
    -moz-transition: height 1s, top 1s;
    -ms-transition: height 1s, top 1s;
    -o-transition: height 1s, top 1s;
    transition: height 1s, top 1s;
  }

  .video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-active.vjs-fullscreen
    .vjs-progress-control,
  .video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-inactive.vjs-fullscreen
    .vjs-progress-control,
  .video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-active.vjs-fullscreen
    .vjs-progress-control,
  .video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-inactive.vjs-fullscreen
    .vjs-progress-control,
  .video-js.vjs-has-started.vjs-playing.vjs-user-inactive.vjs-fullscreen
    .vjs-progress-control {
    opacity: 0;
    -webkit-transition: opacity 1s ease 1s;
    -moz-transition: opacity 1s ease 1s;
    -ms-transition: opacity 1s ease 1s;
    -o-transition: opacity 1s ease 1s;
    transition: opacity 1s ease 1s;
  }

  .video-js.vjs-live .vjs-live-control {
    margin-left: 1em;
  }

  .video-js .vjs-big-play-button {
    top: 50%;
    left: 50%;
    margin-left: -1em;
    margin-top: -1em;
    width: 2em;
    height: 2em;
    line-height: 2em;
    border: none;
    border-radius: 50%;
    font-size: 3.5em;
    background-color: rgba(0, 0, 0, 0.45);
    color: #fff;
    -webkit-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    -moz-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    -ms-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    -o-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
  }

  .video-js .vjs-menu-button-popup .vjs-menu {
    left: -3em;
  }

  .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
    background-color: transparent;
    width: 12em;
    left: -1.5em;
    padding-bottom: 0.5em;
  }

  .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-item,
  .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-title {
    background-color: #151b17;
    margin: 0.3em 0;
    padding: 0.5em;
    border-radius: 0.3em;
  }

  .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-item.vjs-selected {
    background-color: #2483d5;
  }

  .video-js .vjs-big-play-button {
    background-color: rgba(0, 0, 0, 0.45);
    font-size: 3em;
    border-radius: 50%;
    height: 2em !important;
    line-height: 2em !important;
    margin-top: -1em !important;
  }

  .video-js:hover .vjs-big-play-button,
  .video-js .vjs-big-play-button:focus,
  .video-js .vjs-big-play-button:active {
    background-color: #ff8900;
  }

  .video-js .vjs-loading-spinner {
    border-color: #ff8900;
  }

  .video-js .vjs-control-bar2 {
    background-color: #000000;
  }

  .video-js .vjs-control-bar {
    background-color: rgba(0, 0, 0, 0.3) !important;
    color: #ffffff;
    font-size: 14px;
  }

  .video-js .vjs-play-progress,
  .video-js .vjs-volume-level {
    background-color: #ff8900;
  }

  .video-js {
    font-size: 14px;
    overflow: hidden;
  }

  .video-js .vjs-control {
    color: inherit;
  }

  .video-js .vjs-menu-button-inline:hover,
  .video-js.vjs-no-flex .vjs-menu-button-inline {
    width: 8.35em;
  }

  .video-js
    .vjs-volume-menu-button.vjs-volume-menu-button-horizontal:hover
    .vjs-menu
    .vjs-menu-content {
    height: 3em;
    width: 6.35em;
  }

  .video-js .vjs-control:focus:before,
  .video-js .vjs-control:hover:before {
    text-shadow: 0 0 1em #fff, 0 0 1em #fff, 0 0 1em #fff;
  }

  .video-js .vjs-spacer,
  .video-js .vjs-time-control {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-flex: 1 1 auto;
    -moz-box-flex: 1 1 auto;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
  }

  .video-js .vjs-time-control {
    -webkit-box-flex: 0 1 auto;
    -moz-box-flex: 0 1 auto;
    -webkit-flex: 0 1 auto;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    width: auto;
  }

  .video-js .vjs-time-control.vjs-time-divider {
    width: 14px;
  }

  .video-js .vjs-time-control.vjs-time-divider div {
    width: 100%;
    text-align: center;
  }

  .video-js .vjs-time-control.vjs-current-time {
    margin-left: 1em;
  }

  .video-js .vjs-time-control .vjs-current-time-display,
  .video-js .vjs-time-control .vjs-duration-display {
    width: 100%;
  }

  .video-js .vjs-time-control .vjs-current-time-display {
    text-align: right;
  }

  .video-js .vjs-time-control .vjs-duration-display {
    text-align: left;
  }

  .video-js .vjs-play-progress:before,
  .video-js .vjs-progress-control .vjs-play-progress:before,
  .video-js .vjs-remaining-time,
  .video-js .vjs-volume-level:after,
  .video-js .vjs-volume-level:before,
  .video-js.vjs-live .vjs-time-control.vjs-current-time,
  .video-js.vjs-live .vjs-time-control.vjs-duration,
  .video-js.vjs-live .vjs-time-control.vjs-time-divider,
  .video-js.vjs-no-flex .vjs-time-control.vjs-remaining-time {
    display: none;
  }

  .video-js.vjs-no-flex .vjs-time-control {
    display: table-cell;
    width: 4em;
  }

  .video-js .vjs-progress-control {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 0.5em;
    top: -0.5em;
  }

  .video-js .vjs-progress-control .vjs-load-progress,
  .video-js .vjs-progress-control .vjs-play-progress,
  .video-js .vjs-progress-control .vjs-progress-holder {
    height: 100%;
  }

  .video-js .vjs-progress-control .vjs-progress-holder {
    margin: 0;
  }

  .video-js .vjs-progress-control:hover {
    height: 1.5em;
    top: -1.5em;
  }

  .video-js .vjs-control-bar {
    -webkit-transition: -webkit-transform 0.1s ease 0s;
    -moz-transition: -moz-transform 0.1s ease 0s;
    -ms-transition: -ms-transform 0.1s ease 0s;
    -o-transition: -o-transform 0.1s ease 0s;
    transition: transform 0.1s ease 0s;
  }

  .video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-active
    .vjs-control-bar,
  .video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-inactive
    .vjs-control-bar,
  .video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-active
    .vjs-control-bar,
  .video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-inactive
    .vjs-control-bar,
  .video-js.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-control-bar {
    visibility: visible;
    opacity: 1;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translateY(3em);
    -moz-transform: translateY(3em);
    -ms-transform: translateY(3em);
    -o-transform: translateY(3em);
    transform: translateY(3em);
    -webkit-transition: -webkit-transform 1s ease 0s;
    -moz-transition: -moz-transform 1s ease 0s;
    -ms-transition: -ms-transform 1s ease 0s;
    -o-transition: -o-transform 1s ease 0s;
    transition: transform 1s ease 0s;
  }

  .video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-active
    .vjs-progress-control,
  .video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-inactive
    .vjs-progress-control,
  .video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-active
    .vjs-progress-control,
  .video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-inactive
    .vjs-progress-control,
  .video-js.vjs-has-started.vjs-playing.vjs-user-inactive
    .vjs-progress-control {
    height: 0.25em;
    top: -0.25em;
    pointer-events: none;
    -webkit-transition: height 1s, top 1s;
    -moz-transition: height 1s, top 1s;
    -ms-transition: height 1s, top 1s;
    -o-transition: height 1s, top 1s;
    transition: height 1s, top 1s;
  }

  .video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-active.vjs-fullscreen
    .vjs-progress-control,
  .video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-inactive.vjs-fullscreen
    .vjs-progress-control,
  .video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-active.vjs-fullscreen
    .vjs-progress-control,
  .video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-inactive.vjs-fullscreen
    .vjs-progress-control,
  .video-js.vjs-has-started.vjs-playing.vjs-user-inactive.vjs-fullscreen
    .vjs-progress-control {
    opacity: 0;
    -webkit-transition: opacity 1s ease 1s;
    -moz-transition: opacity 1s ease 1s;
    -ms-transition: opacity 1s ease 1s;
    -o-transition: opacity 1s ease 1s;
    transition: opacity 1s ease 1s;
  }

  .video-js.vjs-live .vjs-live-control {
    margin-left: 1em;
  }

  .video-js .vjs-big-play-button {
    top: 50%;
    left: 50%;
    margin-left: -1em;
    margin-top: -1em;
    width: 2em;
    height: 2em;
    line-height: 2em;
    border: none;
    border-radius: 50%;
    font-size: 3.5em;
    background-color: rgba(0, 0, 0, 0.45);
    color: #fff;
    -webkit-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    -moz-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    -ms-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    -o-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
    transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
  }

  .video-js .vjs-menu-button-popup .vjs-menu {
    left: -3em;
  }

  .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
    background-color: transparent;
    width: 12em;
    left: -1.5em;
    padding-bottom: 0.5em;
  }

  .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-item,
  .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-title {
    background-color: #151b17;
    margin: 0.3em 0;
    padding: 0.5em;
    border-radius: 0.3em;
  }

  .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-item.vjs-selected {
    background-color: #2483d5;
  }

  .video-js .vjs-big-play-button {
    background-color: rgba(0, 0, 0, 0.45);
    font-size: 3em;
    border-radius: 50%;
    height: 2em !important;
    line-height: 2em !important;
    margin-top: -1em !important;
  }

  .video-js:hover .vjs-big-play-button,
  .video-js .vjs-big-play-button:focus,
  .video-js .vjs-big-play-button:active {
    background-color: #ff8900;
  }

  .video-js .vjs-loading-spinner {
    border-color: #ff8900;
  }

  .video-js .vjs-control-bar2 {
    background-color: #000000;
  }

  .video-js .vjs-control-bar {
    background-color: rgba(0, 0, 0, 0.3) !important;
    color: #ffffff;
    font-size: 14px;
  }

  .video-js .vjs-play-progress,
  .video-js .vjs-volume-level {
    background-color: #ff8900;
  }

  .video-js {
    width: 95vw;
    max-width: 1000px;
    height: 562px;
    background: rgba(255, 255, 255, 0.5);
    transition: opacity 0.25s;
    border-radius: 10px;
    margin: auto;

    @media (max-width: 1024px) {
      height: 393px;
      width: 700px;
    }

    @media (max-width: 720px) {
      height: 309px;
      width: 550px;
    }

    @media (max-width: 550px) {
      margin-top: 20px;
      height: 210px;
      width: 360px;
    }
  }

  .title {
    color: #232d42;
    margin-right: 30px;
    margin-bottom: 0px;
    display: inline-block;
    padding-top: 5px;
  }

  .main-title {
    font-family: "Montserrat Bold";
    font-size: 40px;
    color: #232d42;
    margin-bottom: 30px;

    @media (max-width: 1024px) {
      font-size: 32px;
    }
  }

  .up-next {
    margin-bottom: 32px;
    margin-left: 40px;

    @media (max-width: 1024px) {
      margin-left: 0px;
      margin-top: 35px;
    }
  }

  .video-collective-container {
    justify-content: space-between;
    max-width: 1000px;
    @media (max-width: 720px) {
    }
  }

  .video-assets-container {
    display: flex;
    flex-direction: row;
    margin-top: 60px;

    @media (max-width: 1024px) {
      flex-direction: column;
      align-items: center;
    }

    @media (max-width: 550px) {
      margin-top: 120px;
    }
  }

  .video-info {
    flex-direction: column;
    margin-left: 0px;
    font-family: 'NunitoSans Bold';
    line-height: 2;
    margin-right: 60px;

    @media (max-width: 1024px) {
      margin-right: 0px;
    }

    @media (max-width: 720px) {
      text-align: center;
    }

    .video-info-clickables {
      margin-top: 35px;
    }

    .video-description {
      color: #747b8a;
      font-weight: 600;
    }

    .show-more-text {
      margin-top: 40px;
      font-size: 16px;
      color: #f5707f;
    }

    .show-more-container {
      @media (max-width: 550px) {
        text-align: center;
        margin: 0 auto;
      }
    }

    .show-more-container div {
      font-size: 16px;


      @media (max-width: 720px) {
        width: 95%;
        margin: 0 auto;
      }

      @media (max-width: 550px) {
        text-align: center;

      }
    }

    @media (max-width: 1024px) {
      padding-right: 0px;
      min-width: 0;
    }

    @media (max-width: 768px) {
      align-items: center;
      justify-content: center;
    }
  }

  .button {
    color: white !important;
  }

  .tags-container {
    margin-top: 25px;

    ul {
      @media (max-width: 720px) {
        width: 680px;
        justify-content: center;
        margin: 30px 0;
        flex-wrap: wrap;
      }

      @media (max-width: 620px) {
        width: 500px
        flex-wrap: wrap;
        max-width: 320px;
        margin: 40px auto 0px auto;
      }
    }
  }

  .share-buttons-container {
    align-items: center;
    margin-top: 20px;
    margin-left: 0px;
    display: flex;
    flex-direction: row;
      @media (max-width: 720px) {
          justify-content: center;

      }
  }
  

  .SocialMediaShareButton {
    display: flex;
    margin-right: 20px;
  }

  .keyword-container.button {
    background: white;
    border: 1px solid #d3d6d9 !important;

    .keyword-name {
      color: black;
    }

    &:hover {
    cursor: default;
      background: #4778ff;
      .keyword-name {
        color: white;
      }
    }
  }

  .carousel-container {
    border-left: 2px solid #ebeff3;
    @media (max-width: 720px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
    }

    @media (max-width: 1024px) {
      border-left: none;
    }
  }

  .carousel {
    @media (max-width: 720px) {
      max-width: 475px;
      margin-left: auto !important;
      margin: 0 auto;
    }

    @media (max-width: 550px) {
      max-width: 375px;
      max-height: 400px;
      margin-left: 20px !important;
      margin: 60px auto;
    }
  }

  .carousel__slider-tray-wrapper {
    padding-bottom: 198% !important;

    @media (max-width: 1024px) {
      padding-bottom: 0px !important;
    }
  }

  .carousel-button {
    background: transparent !important;
    border: none !important;
    font-size: 0;
    &:focus {
      outline: 0;
    }
    &:active {
      background: transparent !important;
    }
  }

  .carousel-next-arrow {
    position: absolute;
    bottom: -30px;
    left: 25px;
    min-width: 20px;
    max-width: 140px;
    z-index: 100;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);

    @media (max-width: 1024px) {
      top: 10px;
      left: 610px;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    @media (max-width: 720px) {
      top: 10px;
      left: 390px;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    @media (max-width: 550px) {
      top: 10px;
      bottom: -30px;
      left: 140px;
    }

  }

  .carousel-back-arrow {
    position: absolute;
    top: -60px;
    left: 55px;
    min-width: 20px;
    max-width: 140px;
    z-index: 100;
    -webkit-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);

    @media (max-width: 1024px) {
      top: -18px;
      left: -60px;
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -o-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
      transform: rotate(180deg);
    }

    @media (max-width: 720px) {
      top: -18px;
      left: -70px;
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -o-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
      transform: rotate(180deg);
    }

    @media (max-width: 550px) {
      top: -21px;
      left: -58px;
    }

  }

  
`;

export default VideoStyles;
